/*
Author: Chathuraka Mallawa Arachchi
Date: 26/12/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import InputField from "@/components/Atoms/InputField";
import InputLabel from "@/components/Atoms/InputLabel";
import {useResponseId,useUrlType} from "@/components/hooks";
import {RootState} from "@/reducers/store";
import {useValidate} from "@/state/survey/formSlice";
import {BasicAnswerSave,useUpdateAnswersSubmit} from "@/state/survey/saveAnswerSlice";
import {Utility,Validate} from "@/utils";
import {useEffect,useRef,useState} from "react";
import {useSelector} from "react-redux";
import poaAnswerDetails from "../../SurveyModel/poaQuestions/poaAnswerDetails";


const TelephoneNo = (props:any) => {
    const {node, name, children, disabled} = props;
    const form = useSelector((state:RootState) => state.form);
    const validateInputField = useValidate();
    const [questionName, setQuestionName] = useState('') 
    const { state = {} } = form[node.name];
    const [inputValue, setInputValue ] = useState(form[node.name].value);
    const {isPatient} = useUrlType();
    const {answerResponseId} = useResponseId();
    const hasExecuted = useRef(false);
    const updateAnswersDispatch = useUpdateAnswersSubmit();

    const handleOnChange = (value: string, name: string) => {
        validateInputField(name, value, true);
        if(node.validationDependants) {
            node.validationDependants.forEach((element : string)=> {
                validateInputField(element, form[element].value, true);
            });
        }
    }

    useEffect(()=>{

        if(form[node.name].value !== inputValue){
            setInputValue(form[node.name].value )
        }
    }, [form, inputValue]);

    useEffect(()=>{
        if(!isPatient && name && form[node.name] && questionName != name && !hasExecuted.current){ //poa only
            validateInputField(name, form[node.name].value, true);
            setQuestionName(name)
            hasExecuted.current = true;
        }
    }, [form, questionName, node, isPatient, name,validateInputField ])

         
    const handleOnBlur = () => {
        if(!isPatient && answerResponseId) {
            const answers: BasicAnswerSave[] = poaAnswerDetails.generateQuestionAnswerSubmitFormat(form,node )
            updateAnswersDispatch(answers, answerResponseId);
        }     
    }

    return (
        <div className={`telephone-no-wrap  
            ${Utility.getClassForWidthPx(node)}  
            ${Utility.getClassForWidth(node)}  
             ${node.name}
            user-input flex-1 number-input 
            question-bottom-space-1
            ${!isPatient ? 'poa-input': '' }
            input-border-top`}>
            <InputLabel label={node.title} labelClasses="input-label"></InputLabel>
            {node.subTitle ? <InputLabel type="subTitle" label={node.subTitle } labelClasses="input-label"></InputLabel> : ''}
            {form ? <InputField disabled={disabled} form={form} isInValid = {Validate.isInvalid(state)} propClasses={'number-input flex'}  type="text" value={form[node.name].value} name={name} onBlur={handleOnBlur} onChange={handleOnChange} /> : '' }
            <div>{children}</div>
        </div>
    )
}

export default TelephoneNo;
